import logo from './logo.svg';
import './App.css';
import HistPanel from './HistPanel'

function App() {
  return (
    <div className="App">
      <HistPanel/>
    </div>
  );
}

export default App;

